import React, { useEffect, useState } from "react";
import { Table, Button, message, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../api";
import ConductorModal from "../components/ConductorModal";

const ConductoresPage = () => {
  const [conductores, setConductores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingConductor, setEditingConductor] = useState(null);

  const getConductores = async () => {
    try {
      setLoading(true);
      const res = await api.get("/conductores");
      setConductores(res.data.data || res.data || []);
    } catch (err) {
      message.error("Error al obtener conductores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConductores();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/conductores/${id}`);
      message.success("Conductor eliminado exitosamente");
      getConductores();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        message.error(err.response.data.message);
      } else {
        message.error("Error al eliminar conductor");
      }
    }
  };

  const showEditModal = (conductor) => {
    setEditingConductor(conductor);
    setOpen(true);
  };

  const closeAndRefresh = () => {
    setOpen(false);
    setEditingConductor(null);
    getConductores();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: 600, margin: 0 }}>Lista de Conductores</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingConductor(null);
            setOpen(true);
          }}
        >
          Nuevo Conductor
        </Button>
      </div>
      <Table
        dataSource={conductores}
        loading={loading}
        rowKey="idconductores"
        columns={[
          { title: "Cédula", dataIndex: "cedula" },
          { title: "Nombre", dataIndex: "nombre" },
          {
            title: "Acciones",
            render: (_, record) => (
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  type="text"
                  icon={<EditOutlined style={{ color: "#1677ff" }} />}
                  onClick={() => showEditModal(record)}
                />
                <Popconfirm
                  title="¿Está seguro de eliminar este conductor?"
                  onConfirm={() => handleDelete(record.idconductores)}
                  okText="Sí"
                  cancelText="No"
                  placement="topRight"
                >
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]}
        scroll={{ x: 'max-content' }}
      />

      <ConductorModal
        open={open}
        conductor={editingConductor}
        onCancel={() => {
          setOpen(false);
          setEditingConductor(null);
        }}
        onSuccess={closeAndRefresh}
      />
    </>
  );
};

export default ConductoresPage;
